export const Env = {
    ...{
        production: false,
        baseUrl: "https://api-dev.flexijobapp.com/api",
        url: "https://api-dev.flexijobapp.com/",
        googleApiKey: "AIzaSyBtHNeCHP9_j21BU0XTUppFKn1mYQ8WhtI"
    }, // any custom env config here
    // --------------------------------------------------------------------
    // base env config here (this imported as separate JS script in Angular.Json as separated script)
}